const state = {
  total_count: 0,
  platoon_list: [{
    slug: '',
    name: '',
    level: '',
    gender: '',
    grade: 0,
    member_count: true,
    mentor_name: '',
    mentor_slug: '',
  }],
  platoon: {
    editable: false,
    slug: '',
    rate: null,
    name: '',
    level: '',
    gender: '',
    grade: 0,
    rasa: false,
    step: null,
    closed_date: null,
    city: null,
    location: '',
    mentor: {name: '', slug: ''},
    members: [{id: 0, name: '', slug: '', status: '', school_name:'', school_slug: '', is_secretary: false}, ],
  },
}

const getters = {
  PlatoonList: state => state.platoon_list,
  PlatoonTotalCount: state => state.total_count,
  Platoon: state => state.platoon,
}

const mutations = {
  setPlatoon(state, payload) { state.platoon=payload },
  setPlatoonList(state, payload) { state.platoon_list=payload.list; state.total_count=payload.total_count },
  setPlatoonListPush(state, payload) { state.platoon_list=state.platoon_list.concat(payload.list); state.total_count=payload.total_count },
  setPlatoonInactive(state) { state.platoon.closed_date='closed' },
  setPlatoonInactiveInList(state, payload) { state.platoon_list[state.platoon_list.map(item => item.slug).indexOf(payload)].closed_date='closed' },
  setRemoveMemberInPlatoon(state, payload) { state.platoon.members.splice(state.platoon.members.map(item => item.id).indexOf(payload),1) },
  setArchiveMemberInPlatoon(state, payload) { state.platoon.members[state.platoon.members.map(item => item.id).indexOf(payload)].status='inactive' },
  setNewMemberInPlatoon(state, payload) { state.platoon.members.push(payload) },
  setNewPlatoonInPlatoonList(state, payload) { state.platoon_list.push(payload) },
  setPlatoonUpdate(state, payload) { state.platoon.name=payload.name; state.platoon.mentor.name=payload.mentor_name; state.platoon.mentor.slug=payload.mentor_slug },
  setPlatoonUpdateInPlatoonList(state, payload) { let i=state.platoon_list.map(item => item.slug).indexOf(payload.slug); state.platoon_list[i].name=payload.name; state.platoon_list[i].mentor.name=payload.mentor_name; state.platoon_list[i].mentor.slug=payload.mentor_slug },
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
